import React from 'react';

import styles from '../../assets/styles/Onboarding/Onboarding.module.scss';
import { userStore } from '../../stores';
import OnboardLeft from './OnboardLeft';
import StageOne from './StageOne';

const OnboardingStageOne = ({
	switchToAlmostThere2,
	switchToAlmostThere3,
	validationSchema,
	onSubmit,
	loading,
	file,
	selectClick,
}) => {
	return (
		<div className={styles.container}>
			<OnboardLeft
				crumbs1={styles.crumbs__default}
				crumbs2={styles.crumbs__active}
				crumbs3={styles.crumbs__default}
			/>
			<div className={styles.right}>
				<h4
					className={`${styles.text__center} ${styles.text__color__primary} ${styles.text__subtitle} ${styles.mb_10}`}>
					Welcome
					<br />
					{userStore.user.business.tradingName},
				</h4>
				<p className={styles.text__center}>
					We are glad to have you and would love to know
					<br />
					more about your business.
				</p>

				<StageOne
					validationSchema={validationSchema}
					onSubmit={onSubmit}
					loading={loading}
					switchToAlmostThere2={switchToAlmostThere2}
					switchToAlmostThere3={switchToAlmostThere3}
					file={file}
					selectClick={selectClick}
				/>
			</div>
		</div>
	);
};

export default OnboardingStageOne;
